import React from 'react';
import { Link } from 'react-router-dom';
import { staticPostsIndex } from '../../data/staticBlogPosts';
import RouteHead from '../../components/RouteHead/RouteHead';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import './BlogPage.css';

// Static posts only: the prerender step and the sitemap can only see posts that
// ship with the app, so a post that lived elsewhere would never be indexable.
const posts = [...staticPostsIndex].sort(
  (a, b) => new Date(b.published_at) - new Date(a.published_at)
);

const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
};

const BlogPage = () => (
  <div className="blogContainer">
    <RouteHead path="/blog" />

    <Navbar />

    <section className="blogHero">
      <h1>VOIA Travel Blog</h1>
      <p>Tips, guides, and insights for curious travelers.</p>
    </section>

    <section className="blogGrid">
      <div className="blogPosts">
        {posts.map((post) => (
          <Link key={post.slug} to={`/blog/${post.slug}`} className="blogCard">
            {post.cover_image && (
              <div className="blogCardImage">
                <img src={post.cover_image} alt={post.title} loading="lazy" />
              </div>
            )}
            <div className="blogCardContent">
              {post.category && <span className="blogCardCategory">{post.category}</span>}
              <h2 className="blogCardTitle">{post.title}</h2>
              <p className="blogCardExcerpt">{post.excerpt}</p>
              <div className="blogCardMeta">
                {post.published_at && <span>{formatDate(post.published_at)}</span>}
                {post.read_time && <span>{post.read_time} min read</span>}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>

    <Footer variant="lightgray" />
  </div>
);

export default BlogPage;
